import getConfig from 'next/config';

/**
 * @param {string} streamId
 * @param {string} language
 * @returns {Promise<SocialStreamApiResponse>}
 */
const get = (streamId, language) => {
  const { publicRuntimeConfig } = getConfig();

  const headers = {
    Accept: 'application/json',
    'Accept-Language': language,
  };

  return fetch(`${publicRuntimeConfig.socialStreamApiBaseUrl}/${streamId}`, {
    headers,
  }).then((res) => {
    return res.json();
  });
};

export default {
  get,
};
